__webpack_require__.S = {};
var initPromises = {};
__webpack_require__.I = (name) => {
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// handling circular init calls
	initPromises[name] = 1;
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => typeof console !== "undefined" && console.warn && console.warn(msg);;
	var uniqueName = "wp5-starter-react";
	var register = (name, version, factory) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || !activeVersion.loaded && uniqueName > activeVersion.from) versions[version] = { get: factory, from: uniqueName };
	};
	var initExternal = (id) => {
		var handleError = (err) => warn("Initialization of sharing external failed: " + err);
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => module && module.init && module.init(__webpack_require__.S[name])
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult.catch(handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("react-dom", "16.13.1", () => Promise.all([__webpack_require__.e(935), __webpack_require__.e(104)]).then(() => () => __webpack_require__(935)));
			register("react", "16.13.1", () => __webpack_require__.e(294).then(() => () => __webpack_require__(294)));
		}
		break;
	}
	return promises.length && (initPromises[name] = Promise.all(promises).then(() => initPromises[name] = 1));
};